import Cookies from 'js-cookie';

import { GTM_EVENTS } from 'constants/tracking';
import { Window } from 'types/window';
import Amplitude from 'services/Amplitude';
import LocalStorage from 'services/LocalStorage';
import { LocalStorageKey } from 'constants/local-storage';
import { getProductName } from 'helpers/product';

import GTM from './GTM';

declare const window: Window;

export enum SignupAuthMethod {
  Native = 'native',
  Google = 'google',
  Microsoft = 'microsoft',
  Apple = 'apple',
}

export default {
  async handleSignUp(): Promise<any> {
    if (
      LocalStorage.get(
        LocalStorageKey.SignupAlertTriggered || LocalStorage.get(LocalStorageKey.SignupTabChanged)
      )
    ) {
      const signupResumedReasons: string[] = [];

      if (LocalStorage.get(LocalStorageKey.SignupAlertTriggered)) {
        signupResumedReasons.push('alertTriggered');
        LocalStorage.remove(LocalStorageKey.SignupAlertTriggered);
      }

      if (LocalStorage.get(LocalStorageKey.SignupTabChanged)) {
        signupResumedReasons.push('tabChanged');
        LocalStorage.remove(LocalStorageKey.SignupTabChanged);
      }

      Amplitude.logEvent(null, 'SIGNUP_RESUMED', { signupResumedReasons });
    }

    LocalStorage.set(LocalStorageKey.SignupAuthMethod, SignupAuthMethod.Native);

    const promises = [];

    promises.push(
      new Promise((resolve): void => {
        try {
          window.ga((): void => {
            const trackingID = ['staging', 'production'].includes(import.meta.env.VITE_APP_ENV)
              ? 'UA-193291-1'
              : 'UA-193291-34';
            window.ga('create', trackingID, { name: 'website' });
            window.ga('website.send', 'pageview');
            window.ga('website.send', {
              hitType: 'event',
              eventCategory: 'Signup',
              eventAction: 'Done',
              hitCallback: resolve,
            });
          });
        } catch (e) {
          resolve(true);
        }
      })
    );

    return Promise.all(promises);
  },

  handleSignUpWithClick: (type: SignupAuthMethod) => (): void => {
    LocalStorage.set(LocalStorageKey.SignupAuthMethod, type);
    Amplitude.logEvent(null, `Accounts: Sign up with ${type} clicked`);
  },

  async handlePreSignupEvent(organizationId: string | null | undefined): Promise<void> {
    const auth = LocalStorage.get(LocalStorageKey.SignupAuthMethod);
    const productCookie = Cookies.get('product') ?? '';
    const product = getProductName(parseInt(productCookie, 10)).toLowerCase();

    if (GTM.track && auth && organizationId) {
      await GTM.track(GTM_EVENTS.PRE_SIGNUP, {
        auth,
        organization_id: organizationId,
        product,
      });

      LocalStorage.remove(LocalStorageKey.SignupAuthMethod);
    }
  },
};
